import { ClientDoc } from "@/interfaces/interface";
import { state } from "@/store/state";
const URL = 'https://yclients.podpislon.ru/api/';
function bodyRequest(){
    const body = new FormData();
    body.append('salon_id',  ''+state.salon_id)
    body.append('hash', state.hash);
    return body;
}
export default {
    save(salon_id: number, api_key: string){
        const body = new FormData();
        body.append('salon_id',  `${salon_id}`)
        body.append('api_key', api_key);
        return fetch(`${URL}install`,{
            method: 'POST',
            body
        })
        .then(res => res.json())
    },
    getKey(): Promise<string>
    {
        return fetch(`${URL}get-key`,{
            method: 'POST',
            body: bodyRequest()
        })
        .then(res => res.json())
        .then(res => res.apiKey)
    },
    getIsKeyAdded(): Promise<boolean>
    {
        return fetch(`${URL}get-key`,{
            method: 'POST',
            body: bodyRequest()
        })
        .then(res => res.json())
        .then(res => res.status)
    },
    getClientFiles(client_id: string): Promise<{status: boolean, files: {data:ClientDoc[]}}>
    {
        const body = bodyRequest();
        body.append('client_id', client_id);
        return fetch(`${URL}get-files`,{
            method: 'POST',
            body
        })
        .then(res => res.json())
    },
    async getDocByURLFetch(url: string, fileName: string): Promise<{status: boolean, file: string}>
    {
        if(!url){
          console.error('Передан пустой Url');
          throw new Error('Передан пустой Url')
        }
        // eslint-disable-next-line
        return new Promise(async (resolve, reject) => {
          try{
            const response = await fetch('https://yclients.podpislon.ru/api/download-file?url='+url,{
              //mode: 'no-cors',
            });
            
            if (!response.ok) {
              throw new Error(`Error! status: ${response.status}`);
            }
            //Возвращается base64, наверное можно его и отдать в функцию
            const res = response.json(); // скачиваем как Blob-объект
            resolve(res);
          } catch (err) {
            reject(err);
          }
        });
      },
      sendReadyStatus(){
        parent.postMessage(
            {
              type: "iframe_ready",
              payload: {
                success: true,
              },
            },
            "https://yclients.ru"
          );
      },
      getCurClient(){
        parent.postMessage(
            {
              type: "iframe_request_entity",
            },
            "*"
          );
      }
}